import { ElementType } from '@thoughtspot/radiant-react/widgets/form-builder/interface';
export var OrgsTabItem;
(function (OrgsTabItem) {
    OrgsTabItem["ORGANIZATION"] = "";
    OrgsTabItem["USERS"] = "users";
    OrgsTabItem["GROUPS"] = "groups";
    OrgsTabItem["CONTENT"] = "content";
    OrgsTabItem["CREDIT_CONSUMPTION"] = "credit-consumption";
})(OrgsTabItem || (OrgsTabItem = {}));
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE"] = "orgs.save";
    TranslationsKeys["CANCEL"] = "orgs.cancel";
    TranslationsKeys["DELETE"] = "orgs.delete";
    TranslationsKeys["CONFIRM"] = "orgs.confirm";
    TranslationsKeys["MODAL_OK"] = "modal.ok";
    TranslationsKeys["ADD_ORG_PAGE_TITLE"] = "orgs.add.title";
    TranslationsKeys["EDIT_ORG_PAGE_TITLE"] = "orgs.edit.title";
    TranslationsKeys["ORG_NAME_LABEL"] = "orgs.name.label";
    TranslationsKeys["ORG_NAME_INVALID"] = "orgs.name.invalid";
    TranslationsKeys["ORG_NAME_LENGTH_LIMIT"] = "orgs.name.limit.exceed";
    TranslationsKeys["ORG_DESC_LABEL"] = "orgs.desc.label";
    TranslationsKeys["ORG_VALID_FIELD_NAME"] = "orgs.valid.fieldName";
    TranslationsKeys["ORG_VALID_MAX_LIMIT"] = "orgs.valid.maxLimit";
    TranslationsKeys["ADD_ORG_BTN_LABEL"] = "orgs.add.button.label";
    TranslationsKeys["ADD_ORG_SUCCESS_MSG"] = "orgs.add.success.msg";
    TranslationsKeys["UPDATE_ORG_SUCCESS_MSG"] = "orgs.update.success.msg";
    TranslationsKeys["DELETE_ORG_SUCCESS_MSG"] = "orgs.success.delete.msg";
    TranslationsKeys["ORG_NAME_ALREADY_EXISTS"] = "orgs.name.already.exists";
    TranslationsKeys["DELETE_ORG_MODAL_TITLE"] = "orgs.modal.delete.title";
    TranslationsKeys["DELETE_ORG_MODAL_BODY"] = "orgs.modal.delete.body";
    TranslationsKeys["DELETE_ORG_CONFIRM_LABEL"] = "orgs.confirmation.delete.label";
    TranslationsKeys["ORG_VALID_DESC_MAX_LIMIT"] = "orgs.valid.desc.maxLimit";
    TranslationsKeys["ORG_CAN_NOT_DELETE_TITLE"] = "orgs.can.not.delete.title";
    TranslationsKeys["CAN_NOT_DELETE_ORG_DESC"] = "can.not.delete.org.desc";
})(TranslationsKeys || (TranslationsKeys = {}));
export var TeamsContainerTestId;
(function (TeamsContainerTestId) {
    TeamsContainerTestId["LeftPanel"] = "teams-continer-left-panel";
    TeamsContainerTestId["RightPanel"] = "teams-continer-right-panel";
})(TeamsContainerTestId || (TeamsContainerTestId = {}));
export var LeftPanelTestId;
(function (LeftPanelTestId) {
    LeftPanelTestId["LeftPanelComponent"] = "left-panel-component";
    LeftPanelTestId["LeftPanelOptions"] = "left-panel-options";
})(LeftPanelTestId || (LeftPanelTestId = {}));
export var PlanOptionsTestId;
(function (PlanOptionsTestId) {
    PlanOptionsTestId["Container"] = "ContainerTestId";
})(PlanOptionsTestId || (PlanOptionsTestId = {}));
export var sortType;
(function (sortType) {
    sortType["ASC"] = "asc";
    sortType["DESC"] = "desc";
})(sortType || (sortType = {}));
export const getAddEditOrgElementsConfig = (translate) => {
    return [
        {
            id: 'name',
            elementType: ElementType.INPUT,
            config: {
                label: translate(TranslationsKeys.ORG_NAME_LABEL),
                type: 'text',
                wrapContent: true,
            },
            validation: {
                required: true,
                requiredError: translate(TranslationsKeys.ORG_VALID_FIELD_NAME, {
                    field_name: translate(TranslationsKeys.ORG_NAME_LABEL),
                }),
                maxLength: 48,
                maxLengthError: translate(TranslationsKeys.ORG_VALID_MAX_LIMIT, {
                    field_name: translate(TranslationsKeys.ORG_NAME_LABEL),
                }),
            },
        },
        {
            id: 'description',
            elementType: ElementType.INPUT,
            config: {
                label: translate(TranslationsKeys.ORG_DESC_LABEL),
                type: 'textarea',
                wrapContent: true,
            },
            validation: {
                maxLength: 124,
                maxLengthError: translate(TranslationsKeys.ORG_VALID_DESC_MAX_LIMIT, {
                    field_name: translate(TranslationsKeys.ORG_DESC_LABEL),
                }),
            },
        },
    ];
};
//# sourceMappingURL=orgs-interface.js.map